import { Component, Renderer2, Inject, DOCUMENT } from '@angular/core';
import { MenuController, NavController, Platform } from '@ionic/angular';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AppService } from 'src/app/services/app.service';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { AppEnum } from './appenum';
import { ThemingService } from './services/theming.service';
import { TranslateService } from '@ngx-translate/core';
import { TaskSummaryComponent } from './user-panel/tasks/task-summary/task-summary.component';
import { AppSettings } from './app.settings';
import { EncryptionService } from './services/encryption.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

import { IdbService } from './services/idb.service';
import { CustomTranslateService } from './services/custom-translate.service';
import { LoggingService } from './services/logging.service';
import { AppNavigation } from './services/app-navigation';
import { wrapAllMethodsWithLogging } from '../app/core/decorators/log-all-errors.decorator';
declare const gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent {
  isTaskDetailsLoaded = false;
  isLogoLoded = false;
  hashkey: any;
  currentdate: any;
  hours: any;
  minutes: any;
  seconds: any;
  datetime: any;
  months: any;
  username: any;
  url: any;
  CHECK_CRASH_INTERVAL = 10000;
  CRASH_THRESHOLD = 15000;
  UserName: any;
  appPages = [];
  lang: string;
  defaultLanguageSelect: any;
  language: any = [];
  BUCKET_URL: any;
  passUrl: any;
  componentName: any = 'AppComponent';

  private readonly MAIL_APP_SIGNATURES: { key: string; displayName: string; androidReferrer: string }[] = [
    { key: 'gmail', displayName: 'Gmail', androidReferrer: 'android-app://com.google.android.gm' },
    { key: 'outlook', displayName: 'Outlook', androidReferrer: 'android-app://com.microsoft.office.outlook' },
    { key: 'yahoo', displayName: 'Yahoo Mail', androidReferrer: 'android-app://com.yahoo.mobile.client.android.mail' },
    { key: 'samsung-email', displayName: 'Samsung Email', androidReferrer: 'android-app://com.samsung.android.email.provider' },
    { key: 'yandex-mail', displayName: 'Yandex Mail', androidReferrer: 'android-app://ru.yandex.mail' },
    { key: 'protonmail', displayName: 'Proton Mail', androidReferrer: 'android-app://ch.protonmail.android' },
    { key: 'spark', displayName: 'Spark Mail', androidReferrer: 'android-app://com.readdle.spark' },
    { key: 'bluemail', displayName: 'BlueMail', androidReferrer: 'android-app://com.northghost.bluemail.android' }
  ];

  iabBannerVisible = false;
  iabPlatform: 'android' | 'ios' | 'other' = 'other';
  iabMailAppLabel = '';
  iabSteps: string[] = [];
  iabDetectedInfo: { platform: string; mailApp: string; referrer: string | null; browser: string } | null = null;
  iabCurrentUrl = window.location.href || '';
  iabCopied = false;
  iabPrimarySteps: string[] = [];
  iabGenericSteps: string[] = [];
  iabShowOrDivider = false;
  constructor(public _nav: NavController, public platform: Platform, private menu: MenuController,
    private _activatedRoute: ActivatedRoute, public router: Router, public _appServices: AppService,
    private titleService: Title, public _appenum: AppEnum, public _themeService: ThemingService,
    public _translateService: TranslateService, public _TaskSummary: TaskSummaryComponent, public _appSetting: AppSettings,
    public encryptionService: EncryptionService,
    public http: HttpClient,
    private renderer: Renderer2,
    private idbService: IdbService,
    public loggingService: LoggingService,
    private customTranslate: CustomTranslateService,
    private _appNav: AppNavigation,
    @Inject(DOCUMENT) private document: Document

  ) {
    wrapAllMethodsWithLogging(this, this.componentName);
  }

  async ngOnInit() {
    if (window.self !== window.top) {
      window.top.location.href = window.self.location.href;
    }
    this.logPageRefreshIfDetected();   //check once, on load
    this.initVisibilityTracking();
    await this.idbService.runMigrationIfNeeded();
    if (this.detectMailAppInApp()) {
      return;
    }
    await this.continueAppFlow();
  }
  private logPageRefreshIfDetected(): void {
    try {
      const navEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
      const navType = navEntries.length > 0 ? navEntries[0].type : null;
      if (navType === 'reload') {
        this.loggingService.logAppLifecycleEvent('page_refresh', 'AppComponent')
          .catch(err => console.error('lifecycle log failed', err));
      }
    } catch (err) {
      console.error('navigation timing check failed', err);
    }
  }

  private async continueAppFlow(): Promise<void> {
    let taskId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.taskId))
    let orgId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.orgId))
    window.addEventListener('storage', (event) => {
      if (!event.key) return;
      const expectedKey = `inspectionSubmitted_${taskId}_${orgId}`;
      if (event.key === expectedKey) {
        localStorage.removeItem(expectedKey)
        window.location.reload()
      }
    });
    this.loadGoogleMaps();
    this.pagerevisit();
  }

  async pagerevisit() {
    let url = window.location.href;
    const urlObj = new URL(url);
    const rawParam = urlObj.search.replace('?', '').replace(/=+$/, '');;
    const isRealHashKey = rawParam.length >= 5 && rawParam.length <= 8 && !rawParam.includes('=');
    const urlHashKey = isRealHashKey ? rawParam : null;
    const currentHashKey = urlHashKey
      ? urlHashKey
      : this.encryptionService.decrypt(
        this.encryptionService.localstorageDecrypt(
          this._appenum.EntityOfLocalStorageKeys.hashKey
        )
      );
    const taskId = this._appServices.getTaskIdFromCookieByHashKey('authToken', currentHashKey);
    if (taskId) {
      this.gotoDashBoard();
    } else {
      await this.detectDevice();
    }
  }

  /** Logs both directions — tab/app hidden (minimize/switch away) and visible (return). */
  private initVisibilityTracking(): void {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.loggingService.logAppLifecycleEvent('tab_hidden', 'AppComponent')
          .catch(err => console.error('lifecycle log failed', err));
      } else if (document.visibilityState === 'visible') {
        this.loggingService.logAppLifecycleEvent('tab_visible', 'AppComponent')
          .catch(err => console.error('lifecycle log failed', err));
      }
    });
  }

  loadGoogleMaps(): void {
    if ((window as any).google?.maps) { // Prevent duplicate loading
      return;
    }
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places&v=weekly`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
  async setFontsBucket() {
    let assetsBucket = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.assetsBucket));
    this.BUCKET_URL = 'https://storage.googleapis.com/' + assetsBucket;
    const style = this.renderer.createElement('style');
    style.textContent = `
      @font-face {
        font-family: 'inter-400';
        src: url('/assets/fonts/Inter_24pt-Regular.ttf'), url('${this.BUCKET_URL}/frontend-assets/fonts/Inter_24pt-Regular.ttf');
        font-weight: 400;
        font-style: normal;
      }
      @font-face {
        font-family: 'inter-500';
        src: url('/assets/fonts/Inter_24pt-Medium.ttf'), url('${this.BUCKET_URL}/frontend-assets/fonts/Inter_24pt-Medium.ttf');
        font-weight: 500;
        font-style: normal;
      }
      @font-face {
        font-family: 'inter-600';
        src: url('/assets/fonts/Inter_24pt-Medium.ttf'), url('${this.BUCKET_URL}/frontend-assets/fonts/Inter_24pt-Medium.ttf');
        font-weight: 600;
        font-style: normal;
      }
      @font-face {
        font-family: 'inter-700';
        src: url('/assets/fonts/Inter_24pt-Bold.ttf'), url('${this.BUCKET_URL}/frontend-assets/fonts/Inter_24pt-Bold.ttf');
        font-weight: 700;
        font-style: normal;
      }
    `;
    this.renderer.appendChild(this.document.head, style);
  }



  async gotoDashBoard() {
    await this.setFontsBucket()
    this.isTaskDetailsLoaded = true;
    this.isLogoLoded = true;
    this._themeService.myMethod(JSON.parse(this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.themeDetail))).themeconfig);
    this._appNav.navigateRoot(['user-panel/dashboard']);
  }
  async detectDevice() {
    if (this.platform.is('desktop')) {
      if (environment.qualys) {
        await this.handleMobileFlow();
      } else {
        // localStorage.clear();
        this.isTaskDetailsLoaded = true;
        this._appNav.navigateRoot(['page-not-found', { errorcode: 'desktop' }]);
      }
    } else if (this.platform.is('mobileweb') || this.platform.is('pwa')) {
      await this.handleMobileFlow();
    }
  }

  private async handleMobileFlow(): Promise<void> {
    try {
      const currentUrl = window.location.href;
      const urlParts = currentUrl.split('?');
      this.passUrl = urlParts[0];
      console.log("passUrl", this.passUrl)
      const baseUrl = urlParts[0];
      const queryString = urlParts.length > 1 ? urlParts[1].replace(/=+$/, '') : null;
      let cleanedUrl: string;
      let hashKey: string | null = null;
      cleanedUrl = baseUrl.includes('.self.')
        ? baseUrl.replace('.self.', '.')
        : baseUrl;
      // Validate if query is real inspection hash
      if (queryString && this.isInspectionHash(queryString)) {
        // localStorage.clear();
        hashKey = queryString;
        this.router.navigate([], {
          queryParams: {},
          replaceUrl: true
        });
        await this.verifyUrl(hashKey, cleanedUrl);

      } else {
        // Refresh OR internal navigation case
        const storedHash = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.hashKey))
        cleanedUrl = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.Selfurl))
        this.passUrl = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.Originurl))
        if (storedHash) {
          await this.verifyUrl(storedHash, cleanedUrl);
        }
      }

    } catch (error) {
      console.error('handleMobileFlow error:', error);
    }
  }

  private isInspectionHash(value: string): boolean {
    if (value.length < 5 || value.length > 10) return false;
    const hashRegex = /^[a-zA-Z0-9]+$/;
    return hashRegex.test(value);
  }

  async isPrivateWindowOrNot(postJson) {
    let hello = new Uint8Array([72, 101, 108, 108, 111]); // "Hello" in binary form
    let blob = new Blob([hello, ' ', 'world'], { type: 'text/plain' });
    const fileUrl = new File([blob], 'self_' + new Date().getTime().toString(), { type: "text/plain" });
    var isNotPrivate = await this._appServices.insertdummyblob(fileUrl);
    if (isNotPrivate != 'private window') {
      this.callApi(postJson);
    } else {
      this.navigatetopage(postJson)
    }
  }

  callApi(postJson) {
    const logRequest: any = {
      apiEndUrl: environment.endpoint.verifyInspectionURL,
      reqBody: postJson,
    };
    console.log("postJson", postJson)
    this._appServices.postDataWithPromiseWithoutAuth(environment.endpoint.verifyInspectionURL, postJson).then(async (_res) => {
      const responseForLog = {
        ..._res,
        Data: _res.Data.map((item: any) => {
          const { themeDetails, ...rest } = item;
          return rest;
        })
      };
      this.loggingService.handleVerifyInspectionResponseLog(
        _res.StatusCode == 200
          ? 'info'
          : _res.StatusCode == 409
            ? 'warning'
            : 'error',
        logRequest,
        _res.StatusCode,
        _res.Message,
        'verifyInspectionURL Api Call',
        this.componentName,
        environment.endpoint.verifyInspectionURL,
        responseForLog
      );
      this._appServices.isDataLoading.next(false);
      localStorage.removeItem(this.encryptionService.encrypt(this._appenum.EntityOfLocalStorageKeys.authtoken));
      if (_res.StatusCode == 200) {
        this._appServices.addTaskIdinUrl(_res.Data[0].taskId)
        this.encryptionService.localstorageEncrypt(
          this._appenum.EntityOfLocalStorageKeys.Selfurl,
          postJson.url
        );
        this.encryptionService.localstorageEncrypt(
          this._appenum.EntityOfLocalStorageKeys.Originurl,
          this.passUrl
        );
        this.encryptionService.localstorageEncrypt(
          this._appenum.EntityOfLocalStorageKeys.hashKey,
          postJson.hashKey
        );
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.taskId, _res.Data[0].taskId)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.orgId, _res.Data[0].orgId)
        this.defaultLanguageSelect = _res.Data[0].themeDetails.language_data.filter(item => item.default)[0].code
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale, this.defaultLanguageSelect)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.defaultLanguageSelected, this.defaultLanguageSelect)
        this.lang = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale))
        this._appSetting.selectedLanguage = this.defaultLanguageSelect;
        await this._translateService.setDefaultLang(this.lang);
        this.isLogoLoded = true;
        this._themeService.myMethod(_res.Data[0].themeDetails.themeconfig);
        this.username = _res.Data[0].FirstName.split(' ');
        this.UserName = _res.Data[0].FirstName;
        var first_name = this.username[0];
        this.language = _res.Data[0].themeDetails.language_data;
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.languageData, JSON.stringify(_res.Data[0].themeDetails.language_data))
        await this._translateService.setDefaultLang(this.lang)
        this._translateService.use(this.lang);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.languageData, JSON.stringify(_res.Data[0].themeDetails.language_data))
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.username, first_name)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.maskmobile, _res.Data[0].userMobile)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.userunmaskmobile, _res.Data[0].userUnmaskedMobile)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.userid, _res.Data[0].userId)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.agentId, _res.Data[0].agentId)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.userEmail, _res.Data[0].userEmail)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.taskStatus, _res.Data[0].taskStatus)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.InspectionStatus, _res.Data[0].status)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.urlExpiryTime, _res.Data[0].urlExpiryTime)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.AgentName, _res.Data[0].agentName)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.AgentMobile, _res.Data[0].agentMobil)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.flag, 'valid')
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.statusManagementFlag, _res.Data[0].statusManagementFlag)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.OrgName, _res.Data[0].themeDetails.orgname)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.shortCode, _res.Data[0].themeDetails.shortcode)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.themeDetail, JSON.stringify(_res.Data[0].themeDetails))
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.supportMobile, _res.Data[0].themeDetails.supportContact)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.supportEmail, _res.Data[0].themeDetails.supportEmail,)
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.assetsBucket, _res.Data[0].themeDetails["assets-bucket"])
        this._appServices.isLangDataLoading.next(true);
        await this.setFontsBucket();
        setTimeout(() => {
          const passData = {
            userid: _res.Data[0].userId,
            maskmobileno: _res.Data[0].userMobile,
            Useremailid: _res.Data[0].userEmail,
            usename: _res.Data[0].FirstName,
            flag: 'valid',
            hashkey: this.hashkey,
            agentName: _res.Data[0].agentName,
            agentMobile: _res.Data[0].agentMobile,
            imageUrl: _res.Data[0].templateImageURL == '' ? '../assets/images/home.png' : _res.Data[0].templateImageURL,
            orgId: _res.Data[0].orgId
          }
          var urlData = this.encryptionService.encrypt(JSON.stringify(passData))
          const savedTaskId = this.encryptionService.decrypt(
            this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.taskId)
          );
          if (!savedTaskId) {
            this.logAllLocalStorage('taskId blank in localStorage before navigating to verify-otp');
          }
          this._appNav.navigate(['verify-otp'], { queryParams: { q: urlData } });
          this.isTaskDetailsLoaded = true;
        }, 500)
      } else if (_res.StatusCode == '403' && _res.Data.length > 0 && _res.Data[0].themeDetails) {
        await this._translateService.setDefaultLang(this.lang)
        this._translateService.use(this.lang)
        this._appServices.loaderDismiss();
        this._themeService.myMethod(_res.Data[0].themeDetails.themeconfig);
        this._appNav.navigateRoot(['linkresponse', { errorcode: _res.StatusCode, errormsg: _res.Message[this._appSetting.selectedLanguage], themeData: true }]);
        this.isTaskDetailsLoaded = true;
      } else if (_res.StatusCode == '409') {
        await this._translateService.setDefaultLang(this.lang)
        this._translateService.use(this.lang)
        this._appServices.loaderDismiss();
        // data: _res.Data 
        const inspectionData = _res.Data?.length ? JSON.stringify(_res.Data[0]) : null;
        this._appNav.navigateRoot(['page-not-found', { errorcode: _res.StatusCode, errormsg: _res.Message['en'], inspectiondata: inspectionData }]);
        this.isTaskDetailsLoaded = true;
      } else {
        await this._translateService.setDefaultLang(this.lang)
        this._translateService.use(this.lang)
        this._appServices.loaderDismiss();
        this._appNav.navigateRoot(['linkresponse', { errorcode: _res.StatusCode, errormsg: _res.Message[this._appSetting.selectedLanguage] }]);
        this.isTaskDetailsLoaded = true;
      }
    }, (err) => {
      this._appServices.loaderDismiss();
      this.loggingService.logApiError(
        'error',
        logRequest,
        err,
        'verifyInspectionURL Api Call',
        this.componentName,
        environment.endpoint.verifyInspectionURL
      )
      this.isTaskDetailsLoaded = true;
    });
  }



  // private async handleMobileFlow() {
  //   // this.url = window.location.href;
  //   this.url = environment.qualys ? 'https://elevon-dev.self.digitaleyes.app?aa1aa' : 'https://elevon-dev.self.digitaleyes.app?43452'
  //   var tempurl = this.url.split('?')[0];
  //   this.passUrl = tempurl;
  //   var newurl = this.url.split('.self.');
  //   this.url = newurl[0] + '.' + newurl[1];
  //   localStorage.removeItem(this.encryptionService.encrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale));
  //   this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.Selfurl, this.url)
  //   this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.Originurl, tempurl)
  //   this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.hashKey, this.url.split('?')[1])
  //   if ((this.url).includes('?')) {
  //     await this.verifyUrl(this.url.split('?')[1]);
  //   }
  // }

  async navigatetopage(data) {
    this.isTaskDetailsLoaded = true;
    var paramRequest = {
      httpRequest: {
        method: 'Private-window',
        url: '',
        payLoad: data,
        response: {
          responseCode: '',
          responseMsg: '',
        },
        // executionTime: ""
      }
    }
    this._appServices.logsActivity(this._appenum.EntityOfLogLevel.Info, 'Self Pwa Open Inspection Link On Private Tab', this.componentName, paramRequest.httpRequest);
    const passData = {
      hashkey: data.hashKey,
      url: this.passUrl
    }
    var urlData = this.encryptionService.encrypt(JSON.stringify(passData))
    this._appNav.navigate(['private-window'], { queryParams: { q: urlData } });
    // this.router.navigate(['private-window'], { queryParams: { q: urlData } });
  }

  async verifyUrl(hashkey, originalUrl) {
    this.hashkey = hashkey;
    // var originUrl = this.url.split('?')[0]
    this.datetime = new Date().toISOString();
    const postJson = {
      hashKey: this.hashkey,
      currentTime: this.datetime,
      url: originalUrl.replace(/\/$/, '')
    };
    console.log("postJson", postJson)
    setTimeout(() => {
      this.isPrivateWindowOrNot(postJson)
    }, 1000)
  }
  closemenu() {
    this.menu.toggle();
  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
  // async googleTracking() {
  //   this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((e) => {
  //     const rt = this.getChild(this._activatedRoute);
  //     rt.data.subscribe(data => {
  //       this.titleService.setTitle(`Digital Eye Self-Inspection | ${data.title}`);
  //       this.googleAnalytics(e);
  //     });
  //   });
  // }

  // googleAnalytics(event) {
  //   var agentid = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentId));
  //   var token = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.authtoken));
  //   if (agentid) {
  //     var pageTitle = this.titleService.getTitle();
  //     gtag('js', new Date());
  //     gtag('get', 'UA-206497206-1', 'client_id', (clientID) => {
  //     });
  //     gtag('set', 'client_id', agentid);

  //     gtag('set', { 'dimension1': agentid });

  //     gtag('set', { 'dimension2': agentid });

  //     gtag('config', 'UA-206497206-1', { cookie_flags: 'max-age=7200;secure;samesite=Strict;' });

  //     gtag('event', 'page_view', {

  //       event: event,

  //       page_title: pageTitle,

  //       page_path: event.urlAfterRedirects

  //     });

  //   }

  // }

  setSiteLocale(event: any) {
    this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale, event.target.value)
    this._appSetting.selectedLanguage = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale));
    this._translateService.use(event.target.value)
    this._appServices.FormErrorMessages();
    this._appServices.changelanguage(true);
  }

  private detectExternalBrowser(ua: string): string {
    if (/EdgA\//i.test(ua)) return 'edge';
    if (/SamsungBrowser\//i.test(ua)) return 'samsungInternet';
    if (/Firefox\//i.test(ua) && !/; wv\)/i.test(ua)) return 'firefox';
    if (/Chrome\//i.test(ua) && !/; wv\)/i.test(ua)) return 'chrome';
    if (/Safari\//i.test(ua) && !/; wv\)/i.test(ua)) return 'safari';
    return 'unknown';
  }

  private detectMailAppInApp(): boolean {
    const ua = navigator.userAgent || '';
    const platform: 'android' | 'ios' | 'other' =
      /android/i.test(ua) ? 'android' :
        /iPhone|iPad|iPod/i.test(ua) ? 'ios' : 'other';

    // Step 1: platform must be Android — iOS/other skipped entirely.
    if (platform !== 'android') {
      return false;
    }

    // Step 2: detect external browser first.
    const externalBrowser = this.detectExternalBrowser(ua);

    // Step 3: check referrer/email-param match.
    const ref = document.referrer || '';
    const referrerMatch = this.MAIL_APP_SIGNATURES.find(app => ref.startsWith(app.androidReferrer));
    const isConfirmedInApp = !!referrerMatch;

    // Step 4: only show steps if referrer/param match was found.
    if (!isConfirmedInApp) {
      return false;
    }

    const resolvedMailApp = referrerMatch?.key || 'email-link';

    this.iabBannerVisible = true;
    this.iabPlatform = platform;
    this.iabMailAppLabel = referrerMatch?.displayName || 'your mail app';
    this.buildOpenExternallySteps(resolvedMailApp);

    this.iabDetectedInfo = {
      platform,
      mailApp: resolvedMailApp,
      referrer: ref || null,
      browser: externalBrowser
    };
    this.logInAppBrowserEvent(this.iabDetectedInfo);
    return true;
  }


  private buildOpenExternallySteps(mailApp: string): void {
    const genericSteps = [
      'Copy the link below or from your mailbox.',
      'Paste it into your browser.',
      'We recommend using Chrome or Safari.'
    ];

    if (mailApp === 'gmail') {
      this.iabPrimarySteps = [
        'Tap the ⋮ (three-dot) menu icon in the top-right corner of this screen',
        'Select "Open in Chrome" from the menu that appears',
        'Once Chrome opens, refresh the page to continue'
      ];
      this.iabGenericSteps = genericSteps;
      this.iabShowOrDivider = true;
    } else {
      this.iabPrimarySteps = [];
      this.iabGenericSteps = genericSteps;
      this.iabShowOrDivider = false;
    }
  }

  private logInAppBrowserEvent(payload: { platform: string; mailApp: string; referrer: string | null; browser: string }): void {
    console.log("In APP BROWSER DETECT", payload);
    // Uncomment once ready to send to backend:
    this.loggingService.logInAppBrowserDetection(
      { platform: payload.platform, mailApp: payload.mailApp, url: window.location.href, referrer: payload.referrer },
      this.componentName,
      'detected'
    ).catch(err => console.error('iab log failed', err));
  }

  async iabCopyLink(): Promise<void> {
    if (!this.iabCurrentUrl) return;
    try {
      await navigator.clipboard.writeText(this.iabCurrentUrl);
      this.iabCopied = true;
      setTimeout(() => (this.iabCopied = false), 2000);
    } catch { /* clipboard may be blocked inside webview */ }
  }

  private logAllLocalStorage(message: string): void {
    const entries: Record<string, string | null> = {};
    let readError = '';
    try {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (!key) continue;
        entries[key] = localStorage.getItem(key);
      }
    } catch (e) {
      readError = String(e);
    }

    this.loggingService.handleLocalStorageLog(
      'info',
      {
        apiEndUrl: 'localStorage',
        reqBody: {
          origin: location.origin,
          count: Object.keys(entries).length,
          readError,
          entries,
        },
      },
      'LS_BEFORE_NAVIGATE_VERIFY_OTP_COMPONENT',
      message,
      message,
      this.componentName,
      'localStorageSnapshot'
    ).catch(err => console.error('localStorage log failed', err));
  }

}

